// ADO-3257 (story D-3, D-4): the revision this tab last showed of each cart, so a read after a
// reload can still tell a send made after the cart the page showed (`sentSinceSeen`).
//
// Kept in `sessionStorage`: per tab, it survives a reload of the tab, and another tab opened later
// has its own. Keyed by cart id (a cart keeps its id after a send, Enabler E8-G AC8). It only
// rises: a revision lower than the one held is a late answer and is not kept. A tab that never
// showed the cart holds nothing, so it names no send (AC4). Every read and write is wrapped:
// private mode or blocked storage just means the tab remembers nothing past a reload.

const KEY_PREFIX = 'shoplink.cartShownRevision';

function keyOf(cartId: string): string {
  return `${KEY_PREFIX}:${cartId}`;
}

/** The revision this tab last showed of `cartId`, or `undefined` when none is held or readable. */
export function shownRevisionOf(cartId: string): number | undefined {
  let raw: string | null;
  try {
    raw = window.sessionStorage.getItem(keyOf(cartId));
  } catch {
    return undefined;
  }
  if (raw === null) return undefined;
  const revision = Number(raw);
  return Number.isInteger(revision) && revision >= 0 ? revision : undefined;
}

/** Remember that this tab showed `cartId` at `revision`, unless it already showed it later. Never
 *  throws. */
export function rememberShownRevision(cartId: string, revision: number): void {
  const held = shownRevisionOf(cartId);
  if (held !== undefined && held >= revision) return;
  try {
    window.sessionStorage.setItem(keyOf(cartId), String(revision));
  } catch {
    // Storage unavailable (private mode, quota): the revision is simply not remembered.
  }
}
